// extracted by mini-css-extract-plugin
module.exports = {"root":"metrics_root__K9gGR","bg":"metrics_bg__PQ_2s","bgTeam":"metrics_bgTeam__qEQX1","line":"metrics_line__mHwxd","trim":"metrics_trim__y8x_W","numbers":"metrics_numbers__Szd7G"};